/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsurancePayment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InsurancePayment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction/EntityType/Payment/PaymentMethod/InsurancePayment"
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="with insurance payment"
/>
{children}
</React.Fragment>)
}